import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const ConnectionLostDialog = ({
  open,
  onRetry,
  onClose,
  retrying = false,
}) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={null}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        style={{
          color: "#d32f2f",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        ⚠ Connection Lost
      </DialogTitle>

      <DialogContent>

        <div
          style={{
            background: "#fff3cd",
            border: "1px solid #ffeeba",
            padding: "15px",
            borderRadius: "6px",
            marginBottom: "15px",
          }}
        >
          <p style={{ marginBottom: 10 }}>
            Connection with the server has been lost.
          </p>

          <p style={{ marginBottom: 10 }}>
            Your latest answers are stored locally.
          </p>

          <p style={{ color: "#d32f2f", fontWeight: 600 }}>
            Please reconnect to continue your assessment.
          </p>
        </div>

      </DialogContent>

      <DialogActions
        style={{
          justifyContent: "center",
          gap: "15px",
          paddingBottom: "20px",
        }}
      >
        <button
          className="btn-negative"
          onClick={onClose}
        >
          Close
        </button>

        <button
          className="btn BlueBtn"
          onClick={onRetry}
          disabled={retrying}
        >
          {retrying ? "Retrying..." : "Retry"}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ConnectionLostDialog;